import { Spin } from "antd";
import { Suspense } from "react";

import type { FC, PropsWithChildren, ReactNode } from "react";

export interface SuspenseFallbackSpinProps extends PropsWithChildren {
  spinner?: ReactNode;
}

export const SuspenseFallbackSpin: FC<SuspenseFallbackSpinProps> = ({ spinner, children }) => {
  return (
    <Suspense
      fallback={
        <div className="flex size-full items-center justify-center">{spinner ?? <Spin />}</div>
      }
    >
      {children}
    </Suspense>
  );
};
